import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { Driver } from 'app/_models/drivers';
import { DriverService } from 'app/_services/drivers.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, finalize } from 'rxjs/operators';
import { PaginationParams } from '../../../_models/generic';

export class DriverDataSource implements DataSource<Driver> {

    private driversSubject = new BehaviorSubject<Driver[]>([]);
    private loadingSubject = new BehaviorSubject<boolean>(false);
    public loading$ = this.loadingSubject.asObservable();
    public paginatorTotalCount: number;

    constructor(private _driverService: DriverService) { }

    loadDrivers(params: PaginationParams, unassigned=true, except=0) {
        this.loadingSubject.next(true);

        this._driverService.getDrivers(params, unassigned, except).pipe(
            catchError(() => of([])),
            finalize(() => this.loadingSubject.next(false))
        ).subscribe(drivers => {
            this.paginatorTotalCount = drivers['count'];
            this.driversSubject.next(drivers['results']);
        });
    }

    findById(id: number): Driver | null {
        const drivers = this.driversSubject.value;
        return drivers.find(rep => rep.id === id) || null;
    }

    connect(collectionViewer: CollectionViewer): Observable<Driver[]> {
        console.log("Connecting Vehicles Admin data source");
        return this.driversSubject.asObservable();
    }

    disconnect(collectionViewer: CollectionViewer): void {
        this.driversSubject.complete();
        this.loadingSubject.complete();
    }
}


// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/shared/components/dl-single-select-drivers/drivers.datasource.ts